import React from 'react';
import {connect} from 'react-redux';
import {setSurveySpeciesValue} from '../../redux/main';

import TextField from '@material-ui/core/TextField';

const TextArea = (props) => {
	const {
		spec_id,
		label,
		id,
		value,
		placeholder,
		setSurveySpeciesValue,
		highlight,
		subhead = false,
	} = props;
	return (
		<>
			<div className={highlight ? 'sub-invert' : 'question-sub'}>{label}</div>
			{subhead ? <div className="textSubhead">{subhead}</div> : null}
			<TextField
				fullWidth
				multiline
				variant="outlined"
				id={id}
				value={value}
				placeholder={placeholder}
				onChange={(ev) => setSurveySpeciesValue(id, ev.target.value, spec_id)}
			/>
		</>
	);
};
export default connect(null, {setSurveySpeciesValue})(TextArea);
